import '../../Pages/Client//Profile.scss';

import { ArrowForward } from '@mui/icons-material';
import { Button} from '@mui/material';
import PropTypes from 'prop-types';
//import {ThemeProvider } from '@mui/material';
import React, { useState } from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { ROLES } from '../../config';
import { DrawEmailIcon, DrawMan2ExpertStep2 } from '../../data/SVGs';
import useAuth from '../../hooks/useAuth';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import usePostRequest from '../../hooks/usePostRequest';
import useRole from '../../hooks/useRole';
import useWindowSize from '../../hooks/useWindowSize';
import UploadImage from '../../Utils/fileUpload/UploadImage';
import {getUrlForAnImage, IMAGE_CONTEXT_ENUM, isHttpStatusSuccess, isUrlFromCompleterProfile, UpperCasePrenomNomFromAuth } from '../../Utils/utils';
import { buttonStyles, buttonStylesBlue } from '../docsAdministrative/JsObjectStyles';
import { TextFieldComponent } from './ReusableSmallComponents';
import SelectRadioBtn from './SelectGender';

export const typeEnum={
    set:'set',
    readOnly:'readOnly',
    update:'update'
};
// * 4 ESN ALSO
function ProfilPersonnelClient({type,titre}) {
    ProfilPersonnelClient.propTypes = {
        type: PropTypes.any,
        titre: PropTypes.any,
    };
    const { auth, setAuth } = useAuth();

    const navigate = useNavigate();
    const role =useRole();
    const axiosPrivate = useAxiosPrivate();
    const {pathname} = useLocation();
    const [image1, setImage1] = useState(null);
    const [originImage1, setOriginImage1] = useState(null);
    const {postData}= usePostRequest();
    const [tele, setTele] = useState();
    const [intitulePoste, setIntitulePoste] = useState();
    const [originIntitulePoste,setOriginIntitulePoste]=useState();
    const [originTele,setOriginTele]=useState();
    const {device}=useWindowSize();
    //const [visibleBtn,setVisibleBtn]=useState(false);
    const [infoClient,setInfoClient]=useState();
    const [imageUrl, setImageUrl]=useState();
    const [disabled, setDisabled]=useState(false);
    const [checkUpdateValue,setCheckUpdateValue]=useState();
    const { i18n } = useTranslation();
    const [prenom,setPrenom]=useState();
    const [genre,setGenre]=useState('');

    const [nom,setNom]=useState();
    const searchInfoClient = async (event) => {
        console.log(event);
        try {
            console.log('test', ROLES.Client, ROLES.Expert,ROLES.Esn, auth.roles);
            if (auth.roles == ROLES.Client){
                const response = await axiosPrivate.get('client/getMyInfos');
                setInfoClient(response.data);
            }
            if (auth.roles == ROLES.Admin){
                const response = await axiosPrivate.get('admin/getMyInfos');
                setInfoClient(response?.data?.backOffice);
            }
            if (auth.roles == ROLES.Esn){
                const response = await axiosPrivate.get('esn/getMyInfos');
                setInfoClient(response.data);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        searchInfoClient();
    },[]);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, [navigate]); // Trigger when the pathname changes

    useEffect(() => {
        console.log(originIntitulePoste);
        console.log(originTele);
        console.log('auth',auth);
        setPrenom(auth?.prenom);
        setNom(auth?.nom);

    },[auth]);

    useEffect(() => {
        if(infoClient){
            if(role=='client'){
                console.log('infoclient',infoClient);
                setOriginTele(infoClient?.collaborator?.persoData?.tele);
                setIntitulePoste(infoClient?.collaborator?.persoData?.intitulePoste);
                setGenre(infoClient?.collaborator?.persoData?.genre);
                setOriginIntitulePoste(infoClient?.collaborator?.persoData?.intitulePoste);
                setTele(infoClient?.collaborator?.persoData?.tele);
                setOriginImage1(infoClient?.collaborator?.persoData?.photo);
                setImageUrl(infoClient?.collaborator?.persoData?.photo);
                setCheckUpdateValue(true);
            }
            if(role=='admin'){
                setOriginTele(infoClient?.persoData?.tele);
                setTele(infoClient?.persoData?.tele);
                setIntitulePoste(infoClient?.persoData?.intitulePoste);
                setGenre(infoClient?.persoData?.genre);
                setOriginIntitulePoste(infoClient?.persoData?.intitulePoste);
                setOriginImage1(infoClient?.persoData?.photo);
                setImageUrl(infoClient?.persoData?.photo);
                setCheckUpdateValue(true);
            }
            if(role=='esn'){
                console.log('infoclient',infoClient);
                setOriginTele(infoClient?.collaboratorEsn?.persoData?.tele);
                setIntitulePoste(infoClient?.collaboratorEsn?.persoData?.intitulePoste);
                setGenre(infoClient?.collaboratorEsn?.persoData?.genre);
                setOriginIntitulePoste(infoClient?.collaboratorEsn?.persoData?.intitulePoste);
                setTele(infoClient?.collaboratorEsn?.persoData?.tele);
                setOriginImage1(infoClient?.collaboratorEsn?.persoData?.photo);
                setImageUrl(infoClient?.collaboratorEsn?.persoData?.photo);
                setCheckUpdateValue(true);
            }
        }
    },[infoClient]);

    useEffect(() => {
        //if((type==typeEnum.set)){
        //    setVisibleBtn(true);
        //}
        if(type==typeEnum?.readOnly){
            setDisabled(true);
        }
    }, []);

    const navigateToNextStep = () => {
        if(isUrlFromCompleterProfile(pathname) && auth.completeStep < 2){
            // * Update the complete step to 2
            setAuth({ ...auth, completeStep: 2 });
        }
        if(type==typeEnum?.set)
            navigate(`/${role}/completeProfile/step2`); // '/client/completeProfile/step2'
    };

    const updatePersoData = async (URL, navigateToNextStep) => {
        const response1 = await postData({url: `/${role}/completePersoData`, payload:
        {
            tele,
            intitulePoste,
            'photo': URL,
            isFromAccountCompletion:isUrlFromCompleterProfile(pathname),
            nom:nom,
            genre:genre,
            prenom:prenom,
        },});
        if(isHttpStatusSuccess(response1.responseStatus)){
            setCheckUpdateValue(true);
            navigateToNextStep();
        }
    };

    const onSubmit = async () => {
        if (image1!=originImage1 || image1) {
            const imageUrl = await getUrlForAnImage(image1, axiosPrivate, IMAGE_CONTEXT_ENUM.collaboratorProfilePic);
            updatePersoData(imageUrl, navigateToNextStep);
        }
        // if there is no uploaded image
        else {
            updatePersoData(null, navigateToNextStep);
        }

    };

    //useEffect(() => {
    //    if((tele!=originTele) || (intitulePoste!=originIntitulePoste)  ){
    //        setVisibleBtn(true);
    //    }
    //}, [tele, intitulePoste]);

    return (
        <>
            <div className='Frame0DonneesPersonnelsExpert'>
                <div className='frame1Profile'>
                    <h1 className='BbtitleProfile'>{titre}</h1>
                </div>

                <div className='rectangleDonneeProfil'>
                    <div className='UploadImgDonneePersonnel'>
                        {role=='admin' &&
                            <>
                                <img
                                    src={imageUrl}
                                    style={{borderRadius:'20px'}}
                                />
                                {device!='desktop' &&
                                <div
                                    className='NompreProfile'
                                >
                                    <h6 className='nomPrenomProfile'>{UpperCasePrenomNomFromAuth(auth?.nom ,auth?.prenom)}</h6>
                                    <div className='nomPreProfile'>
                                        <div className='frame6Profile'>
                                            <DrawEmailIcon />
                                        </div>
                                        <p className='frame7Profile'>
                                            {auth?.email}
                                        </p>
                                    </div>
                                </div>
                                }
                            </>
                        }
                        {(role=='client' || role=='esn' )&&
                            <>
                                <UploadImage
                                    setImage1={setImage1}
                                    image1={image1}
                                    imageUrl={imageUrl}
                                    setImageUrl={setImageUrl}
                                    check={setCheckUpdateValue}
                                />
                                {device!='desktop' &&
                                <div
                                    className='NompreProfile'
                                >
                                    <h6 className='nomPrenomProfile'>{UpperCasePrenomNomFromAuth(auth?.nom ,auth?.prenom)}</h6>
                                    <div className='nomPreProfile'>
                                        <div className='frame6Profile'>
                                            <DrawEmailIcon />
                                        </div>
                                        <p className='frame7Profile'>
                                            {auth?.email}
                                        </p>
                                    </div>
                                </div>
                                }
                            </>
                        }
                    </div>
                    {device =='desktop' &&
                    <div style={{display:'flex',flexDirection:'column',height: '195px'}}>
                        <DrawMan2ExpertStep2 />
                    </div>
                    }
                </div>

                <div className='GrandBox2Step2DonneePersonnel'>
                    <div className='GrandBox2Step2DonneePersonnelPrime'>
                        {device=='desktop' &&
                        <div className='NompreProfile'>
                            <h6 className='nomPrenomProfile'>{UpperCasePrenomNomFromAuth(auth?.nom ,auth?.prenom)}</h6>
                            <div className='nomPreProfile'>
                                <div className='frame6Profile'>
                                    <DrawEmailIcon />
                                </div>
                                <p className='frame7Profile'>
                                    {auth?.email}
                                </p>
                            </div>
                        </div>
                        }
                        <div className='FormStep2ExpertDonneePersonnel'>
                            {(type!=typeEnum?.set && auth.roles != ROLES.Admin) &&
                            <>
                                <SelectRadioBtn
                                    value={genre}
                                    setValue={setGenre}
                                    name="genre"
                                    options={[
                                        { label: 'Madame', optionValue: 'mme' },
                                        { label: 'Monsieur', optionValue: 'mr' }
                                    ]}
                                    setCheckUpdateValue={setCheckUpdateValue}
                                />
                            </>
                            }

                            {type!=typeEnum?.set &&
                            <div style={{ alignSelf: 'stretch', display: 'flex', flexDirection: 'row', gap: '8px' }}>
                                <TextFieldComponent
                                    label={i18n.t('Prénom*')}
                                    value={prenom}
                                    name='prenom'
                                    onChange={(e) => {
                                        setPrenom(e.target.value);
                                        setCheckUpdateValue(false);
                                    }}
                                    sx={{
                                        '& > :not(style)': { borderRadius: '8px' },
                                    }}
                                    style={{ background: 'white', width: '50%', borderRadius: '8px' }}
                                />
                                <TextFieldComponent
                                    label={i18n.t('Nom*')}
                                    value={nom}
                                    name='nom'
                                    onChange={(e) => {
                                        setNom(e.target.value);
                                        setCheckUpdateValue(false);
                                    }}
                                    sx={{
                                        '& > :not(style)': { borderRadius: '8px' },
                                    }}
                                    style={{ background: 'white', width: '50%', borderRadius: '8px' }}
                                />
                            </div>
                            }
                            <TextFieldComponent
                                label={i18n.t('Intitulé du poste')}
                                InputLabelProps={{ shrink: true }}
                                autoComplete="off"
                                sx={{
                                    '& > :not(style)': {borderRadius: '8px'},
                                }}
                                style={{width: '100%',borderRadius: '8px'}}
                                disabled={disabled}
                                value={intitulePoste || ''}
                                onChange={event => {
                                    setIntitulePoste(event.target.value);
                                    setCheckUpdateValue(false);
                                }}
                            />

                            <TextFieldComponent
                                label={i18n.t('Téléphone')}
                                InputLabelProps={{ shrink: true }}
                                sx={{
                                    '& > :not(style)': {borderRadius: '8px',},
                                }}
                                style={{background:'white',width: '100%',borderRadius: '8px'}}
                                disabled={disabled}
                                value={tele || ''}
                                onChange={(event) => {
                                    setTele(event.target.value);
                                    setCheckUpdateValue(false);
                                }}
                            />

                            {((type==typeEnum.update)) &&
                                <div className='frame11Profile'>
                                    <div className='frame12Profile'>
                                        <Button
                                            type="submit"
                                            sx={{height: 56}}
                                            style={{...buttonStylesBlue(checkUpdateValue),...{width:device=='desktop' ?'147px':'100%'}}}
                                            variant='contained'
                                            onClick={onSubmit}
                                            disabled={checkUpdateValue}
                                        >
                                            {i18n.t('Valider')}
                                        </Button>
                                    </div>
                                </div>
                            }
                            {((type==typeEnum?.set)) &&
                                <div style={{ display: 'flex', flexDirection: device=='desktop'?'row':'column',gap:device=='desktop'?'0px':'16px', justifyContent: 'space-between',marginTop:'20px', alignSelf: 'stretch' }}>
                                    <Button
                                        variant="outlined"
                                        style={{...buttonStyles(),...{width:device=='desktop'?'auto':'100%'}}}
                                        onClick={() => {
                                            navigate(`/${role}`);
                                        }}
                                    >
                                        {i18n.t('Remplir plus tard')}
                                    </Button>
                                    <Button
                                        variant="contained"
                                        style={{...buttonStyles(),...{backgroundColor: '#214DCE',color:'white',width:device=='desktop'?'auto':'100%'}}}
                                        startIcon={<ArrowForward />}
                                        onClick={onSubmit}
                                    >
                                        {i18n.t('Valider')}
                                    </Button>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ProfilPersonnelClient;
